import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGettext } from '@jshmrtn/vue3-gettext';
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import { Option } from '@/core/components/form/Option';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSearchSelect',
  props: {
    id: {},
    modelValue: {},
    optionsCb: { type: Function }
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {



const { $gettext } = useGettext();
const emit = __emit;

const optionSelected = (value) => {
	emit('update:modelValue', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Multiselect), {
    id: _ctx.id,
    value: _ctx.modelValue,
    "filter-results": false,
    "min-chars": 1,
    "resolve-on-load": false,
    delay: 700,
    searchable: true,
    options: _ctx.optionsCb,
    "no-options-text": _unref($gettext)('Listan är tom'),
    "no-results-found": _unref($gettext)('Tomt sökresultat'),
    onChange: optionSelected
  }, null, 8, ["id", "value", "options", "no-options-text", "no-results-found"]))
}
}

})